/// <summary>
/// 游戏开关控制逻辑
/// </summary>

import KitAPI from "../KitAPI";
import KitLog from "../KitLog";
import KitAB from "./KitAB";
import {KitEvent} from "../Track/KitEvent";
import { AbCacher } from "./ABCacher";
import {ABConst} from "@/Fwk/Kit/AB/ABConst";

/// <author>xiexingwu</author>
export class ABAllowGameChecker {
//    3）mcc_status：mcc判断开关，无配置时默认打开
    private static MCC_STATUS = "mcc_status";

//    4）vpn_status：vpn判断开关，无配置时默认关闭/
    private static VPN_STATUS = "vpn_status";

//    5）lan_status：系统语言判断开关，无配置时默认关闭
    private static LAN_STATUS = "lan_status";

//    6）ip_status：ip判断开关，无配置时默认关闭
    private static IP_STATUS = "ip_status";
    private static OK = 200; //正常状态，允许使用
    private static EMULATOR = 0; //模拟器
    private static NETWORK_UNAVAILABLE = 1; //无网络
    private static VPN_PROXY = 2; //VPN或者代
    private static IP_COUNTRY = 3; //ip国家/地区
    private static FUNC = 4; //远程配置下发游戏币/玩赚功能关
    private static LANGUAGE = 5; //系统语言中文

    private static MCC = 7; //mcc值

    //是否已经进入游戏主页
    private static hasEnterHomePage = false;
    private static resultCode = this.FUNC;
    private static lastCheckResultCode = -1;

    static Check() {
        //1）无网络时，触发屏蔽
        if (!KitAPI.IsNetworkOk()) {
            KitAB.Log("network is unavailable, intercept>>>");
            this.resultCode = this.NETWORK_UNAVAILABLE;
            return;
        }

        if (KitLog.IsLog) KitAB.Log("network is available, paas");
        //3)func_status下发关闭时，触发屏蔽，默认拦截
        if (!KitAB.getBooleanConfig(ABConst.FUNC_STATUS)) {
            if (KitLog.IsLog) KitAB.Log("func_status is off, intercept>>>");
            this.resultCode = this.FUNC;
            return;
        }

        if (KitLog.IsLog) KitAB.Log("func_status is on, pass");
        this.resultCode = this.OK;
        if (KitLog.IsLog) KitAB.Log("all checkers verify, pass>>>");
    }

    static AllowGame() {
        if (KitLog.IsLog) KitAB.Log("客户端查询开关状态，开始判断是否屏蔽游戏币/玩赚功能");
        this.Check();
        const allow = this.resultCode == this.OK;
        if (KitLog.IsLog) KitAB.Log(`result code:${this.resultCode}, last check result code:${this.lastCheckResultCode}`);
        //进入游戏主页后，开关变更从关->开时上传一次埋点
        if (this.hasEnterHomePage) {
            //统计从关到开状态变化
            if (!allow && this.resultCode != this.OK && this.resultCode != this.lastCheckResultCode) {
                KitAB.Log(`trigger intercept app, type is:${this.resultCode}`);
            }

            if (this.lastCheckResultCode != this.OK && this.resultCode == this.OK) {
                KitAB.Log("=============================================================================");
                KitAB.Log(" func switch has changed 【from off to on】, push a new event(po_state_change)");
                KitAB.Log("=============================================================================");
                let ebKey2: string;
                if (this.lastCheckResultCode == this.MCC)
                    ebKey2 = KitAPI.MCC.toString();
                else
                    ebKey2 = KitAB.curCountry;

                KitEvent.track512(ABConst.PO_STATE_CHANGE)
                    .Put(ABConst.CONSUME_TIME, KitAB.GetStartInterval())
                    .Put1(this.lastCheckResultCode)
                    .Put2(ebKey2)
                    .Commit();
            } else {
                if (KitLog.IsLog)
                    KitAB.Log("checking state is not changed 【from off to on】, will not push event");
            }

            this.lastCheckResultCode = this.resultCode;
        } else {
            if (KitLog.IsLog) KitAB.Log("client has not called enterHomePage yet, will not push event");
        }

        return allow;
    }

    static enterHomePage() {
        this.hasEnterHomePage = true;
        if (KitLog.IsLog) KitAB.Log("客户端进入游戏主场景，开始判断是否屏蔽核心功能");
        this.Check();
        if (KitLog.IsLog) {
            KitAB.Log("=============================================================================");
            KitAB.Log("   client has entered home page, push a new event(enter_home_page)>>>");
            KitAB.Log("=============================================================================");
        }

        const ebKey2 = this.resultCode == this.MCC ? KitAPI.MCC : KitAPI.country;
        KitEvent.track512(ABConst.ENTER_HOME_PAGE)
            .Put(ABConst.CONSUME_TIME, KitAB.GetStartInterval())
            .Put1(this.resultCode)
            .Put2(ebKey2)
            .Put(ABConst.ENTER_INDEX, AbCacher.enterAppCount)
            .Put(ABConst.USBMODE, KitAPI.IsOpenedUSBDebug() ? 1 : 0)
            .Put(ABConst.DEVMODE, KitAPI.IsOpenDevelopmentSetting() ? 1 : 0)
            .Commit();

        KitEvent.track512(ABConst.PO_STATE_CHANGE)
            .Put(ABConst.CONSUME_TIME, KitAB.GetStartInterval())
            .Put1(this.lastCheckResultCode)
            .Put2(ebKey2)
            .Commit();
        this.lastCheckResultCode = this.resultCode;
    }
}
